<script setup lang="ts">
defineOptions({
  inheritAttrs: false
})

const model = defineModel<string>({ required: true })

withDefaults(
  defineProps<{
    label: string
    placeholder: string
    size?: "xs" | "sm"
  }>(),
  {
    size: "sm"
  }
)
</script>

<template>
  <UInput
    v-bind="$attrs"
    v-model="model"
    :aria-label="label"
    class="min-w-0 w-full"
    leading-icon="i-ph-magnifying-glass"
    :placeholder="placeholder"
    :size="size"
    :ui="{ base: 'dashboard-filter-control', leadingIcon: 'size-3.5 text-(--dash-dim)' }"
  />
</template>
